import React from "react";
import PatientDocuments from "@/pages/sections/PatientDocuments";

// Clinic communications, population and non-healthcare documents — the same workbench, scoped to
// the relevance types that don't belong on a patient chart.
export default function ClinicDocuments() {
  return <PatientDocuments scope="clinic" />;
}
